import { Dispatch, SetStateAction } from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Flex, TableColumnType } from 'antd';

import { ADMIN_ROLE_OPTION_LABELS } from '../../../constants.ts';
import { TAdminType, TModalState } from '../../../types.ts';

import { useTableSortColumns } from '@/hooks';
import { TableActionButton } from '@/widgets/table-action-button';

type THookProps = {
    setRecord: Dispatch<SetStateAction<TAdminType | null>>;
    setModalState: Dispatch<SetStateAction<TModalState>>;
};

export const useColumns = ({
    setModalState,
    setRecord,
}: THookProps): TableColumnType<TAdminType>[] => {
    const sortColumns = useTableSortColumns<TAdminType>();

    return sortColumns([
        {
            width: 70,
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
        },
        {
            key: 'email',
            title: 'Email',
            dataIndex: 'email',
        },
        {
            key: 'role',
            title: 'Role',
            dataIndex: 'role',
            render: (_, record) => ADMIN_ROLE_OPTION_LABELS[record.role],
        },
        {
            key: 'actions',
            width: 100,
            title: 'Actions',
            render: (_, record) => {
                const isSuperAdmin = record.role === 'SUPER_ADMIN';

                return (
                    <Flex gap={4}>
                        <TableActionButton
                            icon={<EditOutlined />}
                            color="primary"
                            onClick={() => {
                                setRecord(record);
                                setModalState((prevState) => ({
                                    ...prevState,
                                    update: true,
                                }));
                            }}
                        />
                        <TableActionButton
                            icon={<DeleteOutlined />}
                            color={!isSuperAdmin ? 'danger' : undefined}
                            disabled={isSuperAdmin}
                            onClick={() => {
                                setRecord(record);
                                setModalState((prevState) => ({
                                    ...prevState,
                                    delete: true,
                                }));
                            }}
                        />
                    </Flex>
                );
            },
        },
    ]);
};
